import React from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'

const Used2016LandRoverInBoerneTexas = () => {
  return (
    <>
      <SeoMeta
        title="Used 2016 Land Rover Ranger Rover Sport For Sale in Boerne & Austin TX | Used 2016 Land Rover Ranger Rover Sport Dealer in Boerne & Austin TX | Used 2016 Land Rover Ranger Rover Sport Specials in Boerne & Austin TX | Used 2016 Land Rover Ranger Rover Sport in Boerne & Austin TX"
        description="The used 2016 Land Rover Ranger Rover Sport for sale in Boerne & Austin, Texas at Mark Motors is born from a relentless drive to create a contemporary yet authentic design. Find your used 2016 Land Rover Range Rover Sport for sale in Boerne & Austin, Texas today!"
        keywords="Used 2016 Land Rover Ranger Rover Sport For Sale in Boerne & Austin TX, Used 2016 Land Rover Ranger Rover Sport Dealer in Boerne & Austin TX, Used 2016 Land Rover Ranger Rover Sport Specials in Boerne & Austin TX, Used 2016 Land Rover Ranger Rover Sport in Boerne & Austin TX, Used 2016 Land Rover Ranger Rover Sport For Sale Near Boerne & Austin TX"
        ogTitle="Used 2016 Land Rover Ranger Rover Sport For Sale in Boerne & Austin TX | Used 2016 Land Rover Ranger Rover Sport Dealer in Boerne & Austin TX | Used 2016 Land Rover Ranger Rover Sport Specials in Boerne & Austin TX | Used 2016 Land Rover Ranger Rover Sport in Boerne & Austin TX"
        ogDescription="The used 2016 Land Rover Ranger Rover Sport for sale in Boerne & Austin, Texas at Mark Motors is born from a relentless drive to create a contemporary yet authentic design. Find your used 2016 Land Rover Range Rover Sport for sale in Boerne & Austin, Texas today!"
      />
      <section className='cm-wrap pt-200'>
        <div className='container'>
        <h1>Used 2016 Land Rover Ranger Rover Sport For Sale in Boerne, Texas at Mark Motors </h1>
        <img src={getImages('new/2016-land-rover-range-rover-sport4.jpg')} alt='Used 2016 Range Rover Land Rover Sport For Sale in Boerne' />
          <div className="widget-paragraph clearfix ">
            <p>The used 2016 Land Rover Ranger Rover Sport for sale in Boerne, Texas at Mark Motors is born from a relentless drive to create a contemporary yet authentic design. With seductive flowing lines and stylish features, the sophisticated design of the used 2016 Land Rover Range Rover Sport for sale in Boerne, Texas is conveyed without compromising its character. The used 2016 Land Rover Range Rover Sport for sale in Boerne, Texas is available in six distinct trim models - Range Rover Sport SE, Range Rover Sport HSE, Range Rover Sport HST, Range Rover Sport Supercharged, Range Rover Sport Autobiography, and Range Rover Sport SVR. It is available in many unique exterior color options such as Fuji White, Yulong White, Aleutian Silver, Indus Silver, Kaikoura Stone, Aruba, Scotia Grey, Corris Grey, Waitomo Grey, Carphatian Grey, Montalcino Red, Firenze Red, Aintgree Green, Loire Blue, Mariana Black, Santorini Black, Zanzibar, Barolo Black, and Estoril Blue. Find your used 2016 Land Rover Range Rover Sport for sale in Boerne, Texas today!
            Find your used 2016 Land Rover Range Rover Sport for sale in Boerne, Texas today!</p>
            &nbsp;
            <h2><span className="s1"><strong>Six Unique Models - </strong></span><strong>Used 2016 Land Rover Ranger Rover Sport in Boerne, Texas</strong></h2>
            <h2>&nbsp;</h2>
            <h2><strong>Used 2016 Land Rover Ranger Rover Sport SE For Sale in Boerne, TX:</strong></h2>
            <p>254 HP TD6 Diesel or 340 HP Supercharged V6 Gasoline Engine.
            Single speed transfer case
            Grille in Dark Atlas with Gloss Black surround
            Fender vent with Dark Atlas fingers, Satin Black mesh and Gloss Black surround
            Body colored upper mirror caps
            19-inch five split-spoke Style 501 alloy wheels
            Seats in Grained leather</p>
            <h2><strong>Used 2016 Land Rover Ranger Rover Sport HSE For Sale in Boerne, TX:</strong></h2>
            <p>254 HP TD6 Diesel or 340 HP Supercharged V6 Gasoline Engine.
              Single speed transfer case
              Grille in Atlas with Gloss Black surround
              Fender vent with Atlas fingers, Atlas mesh and Gloss Black surround
              Body colored upper mirror caps
              Front fog lamps
              20-inch five split-spoke Style 520 alloy wheels
              Seats in Oxford Perforated leather
              Fixed panoramic roof
            </p>
            <h2><strong>Used 2016 Land Rover Ranger Rover Sport HST For Sale in Boerne, TX:</strong></h2>
            <p>380 HP Supercharged 3.0L Supercharged V6 Engine
              Gloss Black theme
              Santorini Black contrast roof
              Unique HST badging on the Gloss Black side vents
              21-inch Dark Satin Grey alloy wheels
              Red Brembo™ branded brake calipers
            </p>
            <h2><strong>Used 2016 Land Rover Ranger Rover Sport Supercharged For Sale in Boerne, TX:</strong></h2>
            <p>510 HP Supercharged 5.0L V8 Engine
              Two Speed transfer case
              Grille in Atlas with Gloss Black surround
              Fender vent with Atlas fingers, Atlas mesh and Gloss Black surround
              Body colored upper mirror caps
              20-inch five split-spoke Style 520 alloy wheels
              Seats in Oxford Perforated leather
              Sliding panoramic sunroof
              Paddle Shift
              Torque Vectoring
              Dynamic Response™
              Terrain Response® 2
              Bright twin tailpipes
              Aluminum treadplates with Range Rover branding
              Supercharged Dynamic includes 21-inch five split-spoke Style 507 with Diamond Turned finish alloy wheels
            </p>
            <h2><strong>Used 2016 Land Rover Ranger Rover Sport Autobiography For Sale in Boerne, TX:</strong></h2>
            <p>510 HP Supercharged 5.0L V8 Engine
              Two Speed transfer case
              Grille in Gloss Black painted mesh with Gloss Black surround
              Fender vent with Gloss Black fingers, Atlas mesh and Gloss Black surround
              Gloss Black upper mirror caps
              Tailgate trim in Gloss Black
              21-inch five split-spoke Style 505 alloy wheels
              Red Brembo™ branded brake calipers
              Seats in Oxford Perforated leather with unique patterns and stitching
              Exclusive interior color themes available for Autobiography models: Espresso/Ivory/Tan and Ebony/Lunar/Cirrus
              Sliding Panoramic roof
              Meridia™ Surround Sound Audio System (825W) with 19 speakers
            </p>
            <h2><strong>Used 2016 Land Rover Ranger Rover Sport SVR For Sale in Boerne, TX:</strong></h2>
            <p>550 HP Supercharged 5.0L V8 Engine
              Unique grille in Gloss Black painted mesh with Gloss Black surround
              Distinct design of fender vent in Gloss Black
              Gloss Black upper mirror caps
              Unique design of front and rear bumpers
              Lower front bumper grille insert and tow eye covers in Gloss Black
              Tailgate trim in Gloss Black
              21-inch five split-spoke Style 517 alloy wheels
              Range Rover script in Gloss Black
              Darkened headlamps with Gloss Black finish to non-reflective surfaces
              Specialized rear spoiler
              Bright quad tailpipes
              Blue Brembo™ branded brake calipers
              Sports seats in Oxford Perforated leather with SVR Pattern
              Available in four interior color themes
            </p>
          </div>
          <div className="widget-paragraph clearfix mt-5">
            <img src={getImages('new/2016-land-rover-range-rover-sport1.jpg')} alt='Used 2016 Range Rover Land Rover Sport For Sale in Boerne'/>
            <h2><span className="s1"><strong>Exterior Features - Used 2016 Land Rover Ranger Rover Sport Dealer in Boerne, TX</strong></span></h2>
            <p>
              The used 2016 Land Rover Ranger Rover Sport for sale in Boerne, Texas.
              &nbsp;
              <strong>Roof and Exterior Styling</strong>
              Metal Roof.
              Body Colored Roof.
              Roof Rack Mounting Provisions.
              Body Colored Upper Mirror Caps.
              Gloss Black Upper Mirror Caps.
              Body Colored Side Sills and Bumpers.
              Sliding Panoramic Roof.
              Fixed Panoramic Roof.
              Contrast Roof - Corris Grey
              Contrast Roof - Indus Silver
              Contrast Roof - Santorini Black
              &nbsp;
              <strong>Glass and Exterior Mirrors</strong>
              Acoustic Laminated Front Windshield.
              Privacy Glass with Solar Attenuating Windshield.
              Heated Windshield.
              Power Windows (front and rear) with Auto Close.
              Rain Sensing Windshield Wipers.
              Heated Wiper Park Position (manual lift away from windshield).
              Heated Rear Window.
              Power Adjustable, Heated Powerfold Exterior Mirrors with Approach Lamps (3).
              Power Adjustable, Heated Powerfold Exterior Mirrors with Approach Lamps and Auto-Dimming (3) (4).
              &nbsp;
              <strong>Headlamps and Lighting</strong>
              Front Fog Lamps.
              Xenon Headlamps with LED Signature (includes headlamp power wash).
              Adaptive Xenon Headlamps with LED Signature (includes headlamps power wash).
              Automatic Headlamps with High Beam Assist (AHBA) (requires Xenon or Adaptive Xenon Headlamps).
              Follow-Me-Home Lighting.
              Side Repeater Indicators in Mirror.
              Hazard Lights Under Heavy Braking.
              &nbsp;
              <strong>Paint</strong>
              Solid Paint.
              Metallic Paint.
              Premium Metallic Paint.
              &nbsp;
              <strong>Towing</strong>
              Trailer Stability Control
              6,614 lbs. Towing Capacity.
              7,716 lbs. Towing Capacity.
              Drivers Assistance Package
              &nbsp;
              <strong>Wheels and Wheel Options</strong>
              19-inch five split-spoke Style 501.
              19-inch five split-spoke Style 501 with Satin Dark Grey finish.
              20-inch five split-spoke Style 520.
              20-inch five split-spoke Style 507.
              21-inch five split-spoke Style 507.
              21-inch five split-spoke Style 507 with Diamond Turned finish.
              21-inch five split-spoke Style 505.
              21-inch five split-spoke Style 517.
              21-inch five split-spoke Stye 507 with Satin Dark Grey finish.
              22-inch five split-spoke Style 504.
              22-inch ten split-spoke Style 108.
              Tire Repair System.
              Reduced Section Spare Wheel.
              Full Size Spare Wheel.
              Tire Pressure Monitoring System (TPMS).
              &nbsp;
              <span>Some features only available in select used 2016 Land Rover Ranger Rover Sport vehicles for sale in Boerne, Texas.</span>
            </p>
          </div>
          <div className="widget-paragraph clearfix mt-5">
            <img src={getImages('new/2016-land-rover-range-rover-sport2.jpg')} alt='Used 2016 Range Rover Land Rover Sport For Sale in Boerne'/>
            <h2><span className="s1"><strong>Seating, Interior Features and Trim - Used 2016 Land Rover Ranger Rover Sport Specials in Boerne, Texas</strong></span></h2>
            <p>
              The used 2016 Land Rover Ranger Rover Sport for sale in Boerne, Texas.
              &nbsp;
              <strong>Seating:</strong>
              Grained Leather.
              Oxford Perforated Leather.
              Oxford Perforated Leather with Autobiography Pattern (Single/Duo/Tri Tone).
              Oxford Perforated Leather with SVR Pattern (Single/Duo tone).
              14-Way / 14-Way Powered Seats with Memory and Manual Headrest.
              16-Way / 16-Way Powered Seats with Memory (optional as part of a package).
              16-Way / 16-Way SVR Sports Powered Front Seats with Memory.
              Heated Front Seats.
              Heated Front Seats with Heated Rear Seats (optional as part of a package).
              Climate Front Seats with Heated Rear Seats (optional as part of a package).
              Climate Front Seats with Climate Rear Seats (optional as part of a package).
              60:40 Folding Rear Seats.
              60:40 Folding Rear Seats with Load Through.
              Powered 5+2 Seating (1).
              5+2 Seating Package.
              Head Restraints Two-Way Adjust.
              LATCH/ISOFIX Seat Anchors.
              Second Row Manual Recline.
              &nbsp;
              <strong>Steering Wheel:</strong>
              Power Adjustable Steering Column.
              Leather Steering Wheel with Multi-Functional Controls.
              Leather Heated Steering Wheel (optional as part of a package).
              Leather Heated Steering Wheel with Carbon Fiber Bezel.
              &nbsp;
              <strong>Interior Finishers:</strong>
              Dark Brushed Aluminum Trim Finisher.
              Micro Mesh Aluminum Trim Finisher.
              Sport Textured Aluminum Trim Finisher.
              Dark Engine Turned Aluminum Trim Finisher.
              Shadow Zebrano Wood Veneer Finisher (2).
              Dark Grey Oak Wood Veneer Finisher (2).
              Grand Black Wood Veneer Finisher.
              Carbon Fiber Veneer Finisher.
              &nbsp;
              <strong>Headlining:</strong>
              Morzine Headlining (Cirrus and Ivory).
              Morzine Headlining (Ebony).
              &nbsp;
              <strong>Interior Features:</strong>
              Single Blade Sunvisor.
              Twin Blade Sunvisor.
              Auto-Dimming Interior Mirror.
              Front and Rear Carpet Mats.
              Front and Rear Premium Carpet Mats.
              Aluminum Treadplates with Range Rover Lettering.
              Illuminated Aluminum Treadplates with Range Rover Lettering.
              Bright Metal Sports Pedals.
              Front Center Console Cooler Compartment.
              Two-Zone Climate Control.
              Three-Zone Climate Control.
              Four-Zone Climate Control.
              Interior Mood Lighting.
              Configurable Mood Lighting.
              Driver and Passenger Sunvisor with Illuminated Vanity Mirror.
              Center Armrest with Cubby Box.
              Front and Rear Grab Handles.
              Front and Rear Cupholders.
              Secure Glove Box Storage.
              Smokers Pack.
              &nbsp;
              <strong>Safety and Security</strong>
              Power Operated Child Locks.
              Single Point Entry, Customer Configurable.
              Push Button Keyless Start/Stop.
              Driver and Passenger Airbags (side, seat-front, thorax, pelvis).
              Roll Stability Control (RSC).
              Active Speed Limiter Device (ASL).
              Front Height Adjustable Seat Belts.
              Perimetric Alarm with Engine Immobilization.
              &nbsp;
              <span>Some features only available in select used 2016 Land Rover Ranger Rover Sport vehicles for sale in Boerne, Texas.</span>
            </p>
            <h2><span className="s1"><strong>Convenience and Luggage Compartment Features - Used 2016 Land Rover Ranger Rover Sport For Sale in Boerne, TX</strong></span></h2>
            <p>
              The used 2016 Land Rover Ranger Rover Sport for sale in Boerne, Texas.
              &nbsp;
              <strong>Convenience Features:</strong>
              Rear Park Distance Sensors with Visual Display.
              Front Parking Aid with Front Visual Display.
              Cruise Control.
              Adaptive Cruise Control with Queue Assist, Intelligent Emergency Braking and Active Seat Belts.
              Rear View Camera.
              Surround Camera System.
              Lane Departure Warning with Traffic Sign Recognition.
              Park Assist
              Blind Spot Monitor with Close Vehicle Sensing and Reverse Traffic Detection.
              HomeLink®.
              Soft Door Close.
              Keyless Entry.
              Gesture Tailgate.
              &nbsp;
              <strong>Luggage Compartment Features:</strong>
              Roller Luggage Compartment Cover.
              Luggage Compartment Mounting Provisions.
              &nbsp;
              <strong>Information, Communication and Entertainment:</strong>
              Range Rover Audio System (250W) with Eight Speakers.
              Meridian™ Surround Sound Audio System (825W) with 19 Speakers.
              Meridian Signature Reference Audio System (1700W) with 23 Speakers.
              SiriusXM® Satellite Radio &amp; HD Radio™.
              Eight-Inch Touch-Screen.
              User Selectable Screen Savers.
              Partial TFT / LCD Instrument Cluster.
              TFT Virtual Instrument Panel.
              Hard Disk Navigation System (includes voice control).
              Eight-Inch Rear Seat Entertainment with Remote Control and Two Sets of Wireless Headphones.
              MP3 Compatible Audio Disk.
              One USB Socket in Cubby Box.
              Auxiliary Device Connectivity (full integrated streaming).
              Bluetooth® Audio Streaming and Bluetooth® Phone Connection.
              Auxiliary Power Sockets.
              Land Rover InControl® Apps™.
              Land Rover InControl™ Protect for Warranty Period.
              Land Rover InControl Remote.
              Land Rover InControl Wifi.
              Head Up Display.
              &nbsp;
              <span>Some features only available in select used 2016 Land Rover Ranger Rover Sport vehicles for sale in Boerne, Texas.</span>
            </p>
            <h2><span className="s1"><strong>The World’s Most Capable Performance SUV - Used 2016 Land Rover Ranger Rover Sport In Boerne, TX</strong></span></h2>
            <p>
              <span>The used 2016 Land Rover Ranger Rover Sport for sale in Boerne, Texas at Mark Motors has been designed and engineered through a natural progression beyond the cover vehicle’s outstanding on and off-road capabilities and leading-edge design. With six superior trims, the used 2016 Land Rover Range Rover Sport for sale in Boerne, Texas ensures that you get where you want to go smoothly and with exceptional style. Come and let our experienced team at Mark Motors guide you through our inventory and find your 2016 Land Rover Range Rover Sport for sale in Boerne, Texas today!</span>
              &nbsp;
              <span>Mark Motors proudly serves our customers in Boerne, San Antonio, Fredericksburg, and surrounding areas.</span>
              <span>See dealer or owner's literature for limited warranty details.</span>
            </p>
          </div>
        </div>
      </section>

    </>
  )
}

export default Used2016LandRoverInBoerneTexas